module.exports = __webpack_public_path__ + "assets/media/share-prix_in.845a456c.svg";